import { useState, useEffect } from "react";
import { Form, Spin, Card, Tabs, Row, Checkbox, Col } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import { useNavigate } from "react-router-dom";
import { apiCand } from "../../../services/apiCand";
import { obterAreas, obterOcupacoes, obterPepSituacoes } from "../../../services/apiAuxiliar";

import { colors } from "../../../styles/colors";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import PessoaFisicaDadosPessoais from "./Componentes/PessoaFisicaDadosPessoais";
import PessoaFisicaEndereco from "../Componentes/PessoaFisicaEndereco";
import PessoaFisicaDocumento from "../Componentes/PessoaFisicaDocumento"
import PessoaFisicaEmail from "../Componentes/PessoaFisicaEmail"
import PessoaFisicaTelefone from "../Componentes/PessoaFisicaTelefone"
import PessoaFisicaFormacao from "../Componentes/PessoaFisicaFormacao"
import PessoaFisicaExperiencia from "../Componentes/PessoaFisicaExperiencia"
import PessoaFisicaCertificado from "../Componentes/PessoaFisicaCertificado"
import PessoaFisicaPenalidade from "../Componentes/PessoaFisicaPenalidade"
import PessoaFisicaPepSituacao from "../Componentes/PessoaFisicaPepSituacao"

import { IAreaConhecimento, IErroApi, IOcupacaoPrincipal } from "../../../Interfaces/Interfaces";
import { mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";

import { color, resetColor } from "../../../styles/cnpjColor";
import { errorMessage, successMessage } from "../../../utils/messages";
import "../style.css";
import {
  IDadosReceitaCpf, IFormacaoPessoaFisica, IEnderecoPessoaFisica, IDocumentoPessoaFisica, IEmailPessoaFisica,
  ITelefonePessoaFisica, IExperienciaPessoaFisica, ISituacaoPepPessoaFisica, ICertificadoPessoaFisica, IPenalidadePessoaFisica,
  IPessoaFisica,
  IPepSituacao
} from "../Componentes/InterfacePessoaFisica";
import { useLocation } from "react-router";
import { isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { obterEstados, obterPaises } from "../../../services/apiExternos";
import { IEstado, IPais } from "../../../Interfaces/Localidades";
import { DEFAULT_PAGE_SIZE } from "../../parametrosUI";

interface IGetCpf {
  nmPessoaFisica: string;
  dataSituacaoCadastral: string;
  situacaoCadastral: string;
  mud: boolean;
  validada: boolean;
  manterEdicao: number;
}


const Cadastrar = (props: any) => {
  const { state } = useLocation();

  const [estadoPEP, setEstadoPEP] = useState(false); // FORÇA A ATUALIZAÇÃO DO BOTÃO SALVAR QUANDO SE MUDA O ESTADO DE PEP.
  useEffect(() => {
    //console.log("Estado PEP: " + estadoPEP)
  }, [estadoPEP])

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [dadosReceitaCpf, setDadosReceitaCpf] = useState<IDadosReceitaCpf>({ cpf: "" });


  useEffect(() => {
    if (isStateValid(state)) {
      // Se estiver recebendo dados de um outro cadastro (diretor ou conselheiro, por exemplo)
      if (state && state.idPessoaFisica && state.idPessoaFisica === -1) {
        form.setFieldsValue({
          "nuCpf": state.nuCpf,
        });
      }
    }
    getPaises();
    getEstados();
    getAreas();
    getOcupacoes();
    getPepSituacoes();
  }, []);

  const [paises, setPaises] = useState<IPais[]>([]);
  // Retorna todas os países
  const getPaises = async () => {
    await obterPaises().then((response) => {
      setPaises(response?.data);
    });
  };

  const [estados, setEstados] = useState<IEstado[]>([]);
  // Retorna todos os estados do Brasil (id pais = 1)
  const getEstados = async () => {
    await obterEstados().then((response) => {
      response?.data.sort((a, b) => a.sigla.localeCompare(b.sigla));
      setEstados(response?.data);
    });
  };

  const [areas, setAreas] = useState<IAreaConhecimento[]>([]);
  // Retorna as áreas de conhecimento
  const getAreas = async () => {
    await obterAreas().then((response) => {
      setAreas(response?.data);
    });
  };

  const [ocupacoes, setOcupacoes] = useState<IOcupacaoPrincipal[]>([]);
  const getOcupacoes = async () => {
    await obterOcupacoes().then((response) => {
      setOcupacoes(response?.data);
    });
  };

  const [pepSituacoes, setPepSituacoes] = useState<IPepSituacao[]>([]);
  const getPepSituacoes = async () => {
    await obterPepSituacoes().then((response) => {
      setPepSituacoes(response?.data);
    });
  };


  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])


  useEffect(() => {

    if (manter === -1) { // ESTADO INICIAL
      setDocumentos([]);
      setEmails([]);
      setTelefones([]);
      setEnderecos([]);
      setFormacoes([]);
      setExperiencias([]);
      setCertificados([]);
      setPenalidades([]);
      setPessoaFisicaPepSituacoes([]);
      resetForm();
      setManter(1); // ESTADO DE INCLUSÃO
    }
  }, [manter]);

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [pessoaFisicaRetPosCadastro, setPessoaFisicaRetPosCadastro] = useState<IPessoaFisica>();

  const [documentos, setDocumentos] = useState<IDocumentoPessoaFisica[]>([]);
  const [enderecos, setEnderecos] = useState<IEnderecoPessoaFisica[]>([]);
  const [emails, setEmails] = useState<IEmailPessoaFisica[]>([]);
  const [telefones, setTelefones] = useState<ITelefonePessoaFisica[]>([]);
  const [formacoes, setFormacoes] = useState<IFormacaoPessoaFisica[]>([]);
  const [experiencias, setExperiencias] = useState<IExperienciaPessoaFisica[]>([]);
  const [certificados, setCertificados] = useState<ICertificadoPessoaFisica[]>([]);
  const [penalidades, setPenalidades] = useState<IPenalidadePessoaFisica[]>([]);
  const [pessoaFisicaPepSituacoes, setPessoaFisicaPepSituacoes] = useState<ISituacaoPepPessoaFisica[]>([]);

  // Objeto para utilização de passagens de dados entre as telas
  const [estadoPag] = useState({
    fluxoPagina: 9,
    query: "",
    valores: {
      linhaPorPagina: DEFAULT_PAGE_SIZE,
      cnpj: "",
      numeroProcesso: "",
      registroFiscal: "",
      validada: "",
      pagina: 1,
      razaoSocial: "",
      apenasConsultadosReceita: false,
    },
  });

  useEffect(() => {
    if (pessoaFisicaRetPosCadastro) pushToManter(pessoaFisicaRetPosCadastro);
  }, [pessoaFisicaRetPosCadastro]);

  function pushToManter(pf: IPessoaFisica) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {

      nmPessoaFisica: pf.nmPessoaFisica?.toUpperCase(),
      nuCpf: pf.nuCpf,
      pessoaExpostaPoliticamente: form?.getFieldValue("pessoaExpostaPoliticamente"),
      statusReg: 1,

      manter: 2,
      data: pf
    }
    navigate("/pessoa-fisica/manter", { state: tpSelecao });
  }

  // function pushToManterOld(pf: any) {  // ABRE A TELA DE DETALHES DA PESSOA FÍSICA EM CONSULTAR
  //   let tpSelecao = {
  //     manter: 2,
  //     data: pf
  //   }
  //   navigate("/pessoa-fisica/consultar", { state: tpSelecao });
  // }

  // const [atualizar, setAtualizar] = useState(false);

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [data, setData] = useState<IGetCpf>({
    nmPessoaFisica: "",
    dataSituacaoCadastral: "",
    situacaoCadastral: "",
    mud: true,
    validada: false,
    manterEdicao: 1,
  });

  const [touched, setTouched] = useState(true);

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const cadastro = form.getFieldsValue();
    const json : IPessoaFisica = {
      nuCpf: !cadastro.nuCpf || cadastro.nuCpf === "" ? "" : (onlyNumbers(cadastro.nuCpf)||""),
      nmPessoaFisica: cadastro?.nmPessoaFisica,
      csGrauInstrucao: form?.getFieldValue("csGrauInstrucao"),
      pessoaExpostaPoliticamente: form?.getFieldValue("pessoaExpostaPoliticamente"),
      statusReg: 1,
      pessoaFisicaDocumentos: documentos.map((e: IDocumentoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaEmails: emails.map((e: IEmailPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaTelefones: telefones.map((e: ITelefonePessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaEnderecos: enderecos.map((e: IEnderecoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaFormacoes: formacoes.map((e: IFormacaoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaExperienciasProfissionais: experiencias.map((e: IExperienciaPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaCertificados: certificados.map((e: ICertificadoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaPenalidades: penalidades.map((e: IPenalidadePessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaPepSituacoes: pessoaFisicaPepSituacoes.map((e: ISituacaoPepPessoaFisica) => {
        return {
          ...e
        };
      }),
    };
    //console.log("json subindo");
    //console.log(json);


    await apiCand.post(`/pessoasFisicas`, json).then((response) => {
      setLoading(false);
      resetForm();
      //todo      setDadosPessoaFisicaCadastrada(response?.data);
      successMessage(
        `Pessoa Física ${cadastro?.nmPessoaFisica.toUpperCase()} cadastrada com Sucesso`
      );
      setPessoaFisicaRetPosCadastro(response.data);

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    setData({
      ...data,
      nmPessoaFisica: "",
      manterEdicao: 1,
    });
    setDocumentos([]);
    setEmails([]);
    setTelefones([]);
    setEnderecos([]);
    setFormacoes([]);
    setExperiencias([]);
    setCertificados([]);
    setPenalidades([]);
    setPessoaFisicaPepSituacoes([]);
    form.setFieldsValue({
      nmPessoaFisica: "",
      nuCpf: "",
      pessoaExpostaPoliticamente: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  function verificaEndereco() {  // O BOTÃO SALVAR SOMENTE SERÁ HABILITADO SE EXISTIR PELO MENOS UM ENDEREÇO PESSOAL
    let endOk = false;
    if (enderecos.length > 0) {
      enderecos.forEach((e: IEnderecoPessoaFisica) => {
        if (e.csTpEndereco === 1) endOk = true;

      });
    }
    return endOk;
  }

  function verificaSitSemDtFim() {  // SE EXISTIR PELO MENOS UM REGISTRO COM DT_FIM NULL, RETORNA TRUE
    let existeRegSemDtFim = false;
    if (pessoaFisicaPepSituacoes.length > 0) {
      pessoaFisicaPepSituacoes.forEach((e: ISituacaoPepPessoaFisica) => {
        if (!e.dtFim || e.dtFim === null || e.dtFim === "") existeRegSemDtFim = true;
      });
    }
    return existeRegSemDtFim;
  }

  function verificaItensObrigatorios() {
    if ((documentos && documentos.length > 0) && verificaEndereco()) {
      return true;
    } else {
      return false;
    }
  }

  function isPPE() {
    if (pessoaFisicaPepSituacoes.length > 0 && verificaSitSemDtFim()) {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: true,
      });
      return true;
    } else {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: false,
      });
      return false;
    }
  }

  function desabilitaBotoes() {
    if (form.getFieldValue("nuCpf") === "") {
      return true
    } else {
      return false
    }
  }

  return (
    <>
      {/* <Prompt
        when={form.getFieldValue("nuCpf") && form.getFieldValue("nuCpf") !== ""}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastro de Pessoa Física"
          style={{
            marginTop: "-18px",
            background: colors.blue,
            padding: 5,
            paddingLeft: 24,
            fontSize: "12px",
          }}
        />

        <Card title='Dados Pessoais' variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            // initialValues={{ remember: false }}
            onFinish={sendForm}
            scrollToFirstError
          >

            <>
              <PessoaFisicaDadosPessoais
                form={form}
                color={color}
                loading={loading}
                setLoading={setLoading}
                setTipLoading={setTipLoading}
                setDadosReceitaCpf={setDadosReceitaCpf}
              />
            </>

            <Tabs>
              <Tabs.TabPane tab="Documentos" key="item-1">
                <>
                  <PessoaFisicaDocumento
                    paises={paises}
                    estados={estados}
                    documentos={documentos}
                    setDocumentos={setDocumentos}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="E-mails" key="item-2">
                <>
                  <PessoaFisicaEmail
                    emails={emails}
                    setEmails={setEmails}
                    form={form}
                    color={color}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Telefones" key="item-3">
                <>
                  <PessoaFisicaTelefone
                    telefones={telefones}
                    setTelefones={setTelefones}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Endereços" key="item-4">
                <>
                  <PessoaFisicaEndereco
                    paises={paises}
                    estados={estados}
                    enderecos={enderecos}
                    setEnderecos={setEnderecos}
                    form={form}
                    manter={manter}
                    dadosReceitaCpf={dadosReceitaCpf}
                    setDadosReceitaCpf={setDadosReceitaCpf}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Formação" key="item-5">
                <>
                  <PessoaFisicaFormacao
                    formacoes={formacoes}
                    setFormacoes={setFormacoes}
                    areas={areas}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Experiência Profissional" key="item-6">
                <>
                  <PessoaFisicaExperiencia
                    experiencias={experiencias}
                    setExperiencias={setExperiencias}
                    areas={areas}
                    ocupacoes={ocupacoes}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Certificado" key="item-7">
                <>
                  <PessoaFisicaCertificado
                    certificados={certificados}
                    setCertificados={setCertificados}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Penalidade" key="item-8">
                <>
                  <PessoaFisicaPenalidade
                    penalidades={penalidades}
                    setPenalidades={setPenalidades}
                    form={form}
                    cargos={[]}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>


              <Tabs.TabPane tab="Pessoa Exposta Politicamente" key="item-9">
                <Row>
                  <Col xs={12} xl={12}>
                    <Form.Item
                      name="pessoaExpostaPoliticamente"
                      colon={false}
                    >
                      <Checkbox checked={isPPE()} disabled={true}>Pessoa Exposta Politicamente</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <PessoaFisicaPepSituacao
                  pessoaFisicaPepSituacoes={pessoaFisicaPepSituacoes}
                  setPessoaFisicaPepSituacoes={setPessoaFisicaPepSituacoes}
                  pepSituacoes={pepSituacoes}
                  form={form}
                  manter={manter}
                />
              </Tabs.TabPane>
            </Tabs>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              estadoPag={estadoPag}
              desabilitar={touched}
              setDesabilitar={setTouched}
              desabilitaBotoes={desabilitaBotoes}
              verificaItensObrigatorios={verificaItensObrigatorios}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
            />

          </Form>
        </Card>

      </Spin>

    </>
  );
};

export default Cadastrar;